export const STORE_ELEMENT_ID = 'store-header'
